//---------------------------------------------------
//  Nom du fichier : gradeSelector.js 
//
//  Description: Component qu'on réutilise pour choisir 
//               une difficulté selon le grade type choisi
//
//  Auteur: Alek Del Balso et Vega Laliberté
//---------------------------------------------------

import "./color.css"
import React, { useEffect, useState } from "react";
import { path_dict, eu_to_am, am_to_eu, sections} from './grades';

function GradeSelector({setSelected, gradetype, startWith}){
    const [colorNow, setColorNow] = useState("");

    const handleChange = (value) => {
        setSelected(value);
        let gradeColor = ""
        sections.forEach((section, index) => {
          if (section.includes(value)) {
            gradeColor = path_dict[index];
            setColorNow(gradeColor)
          }
        });
    }

    useEffect(() => {
      handleChange(startWith)
    },[])

    return(
        <select 
        name="grade"
        className="gradeSelector" 
        value={(() => {
            if (gradetype === "american") {
              if (eu_to_am[startWith]) return eu_to_am[startWith];
              else return startWith;
            } else {
              if (am_to_eu[startWith]) {
                let grades = am_to_eu[startWith]
                return grades[0]
              }
              else return startWith;
            }
          })()}

          onChange={e => {handleChange(e.target.value)}} 
          style={{color: `var(--grade${colorNow})`}}>
        {gradetype == 'american' ? 
        <>
            <option className="optionGradeSelector" value="vb"  style={{backgroundColor:"var(--grade01)"}}>vb</option>
            <option className="optionGradeSelector" value="v0"  style={{backgroundColor:"var(--grade01)"}}>v0</option>
            <option className="optionGradeSelector" value="v1"  style={{backgroundColor:"var(--grade01)"}}>v1</option>
            <option className="optionGradeSelector" value="v2"  style={{backgroundColor:"var(--grade23)"}}>v2</option>
            <option className="optionGradeSelector" value="v3"  style={{backgroundColor:"var(--grade23)"}}>v3</option>
            <option className="optionGradeSelector" value="v4"  style={{backgroundColor:"var(--grade45)"}}>v4</option>
            <option className="optionGradeSelector" value="v5"  style={{backgroundColor:"var(--grade45)"}}>v5</option>
            <option className="optionGradeSelector" value="v6"  style={{backgroundColor:"var(--grade67)"}}>v6</option>
            <option className="optionGradeSelector" value="v7"  style={{backgroundColor:"var(--grade67)"}}>v7</option>
            <option className="optionGradeSelector" value="v8"  style={{backgroundColor:"var(--grade89)"}}>v8</option>
            <option className="optionGradeSelector" value="v9"  style={{backgroundColor:"var(--grade89)"}}>v9</option>
            <option className="optionGradeSelector" value="v10" style={{backgroundColor:"var(--grade1011)"}}>v10</option>
            <option className="optionGradeSelector" value="v11" style={{backgroundColor:"var(--grade1011)"}}>v11</option>
            <option className="optionGradeSelector" value="v12" style={{backgroundColor:"var(--grade1213)"}}>v12</option>
            <option className="optionGradeSelector" value="v13" style={{backgroundColor:"var(--grade1213)"}}>v13</option>
            <option className="optionGradeSelector" value="v14" style={{backgroundColor:"var(--grade1415)"}}>v14</option>
            <option className="optionGradeSelector" value="v15" style={{backgroundColor:"var(--grade1415)"}}>v15</option>
            <option className="optionGradeSelector" value="v16" style={{backgroundColor:"var(--grade1617)"}}>v16</option>
            <option className="optionGradeSelector" value="v17" style={{backgroundColor:"var(--grade1617)"}}>v17</option>
        </>
        :
        <>
            <option className="optionGradeSelector" value="3"   style={{backgroundColor:"var(--grade01)"}}>3</option>
            <option className="optionGradeSelector" value="4-"  style={{backgroundColor:"var(--grade01)"}}>4-</option>
            <option className="optionGradeSelector" value="4"   style={{backgroundColor:"var(--grade01)"}}>4</option>
            <option className="optionGradeSelector" value="4+"  style={{backgroundColor:"var(--grade01)"}}>4+</option>
            <option className="optionGradeSelector" value="5"   style={{backgroundColor:"var(--grade01)"}}>5</option>
            <option className="optionGradeSelector" value="5+"  style={{backgroundColor:"var(--grade23)"}}>5+</option>
            <option className="optionGradeSelector" value="6A"  style={{backgroundColor:"var(--grade23)"}}>6A</option>
            <option className="optionGradeSelector" value="6A+" style={{backgroundColor:"var(--grade23)"}}>6A+</option>
            <option className="optionGradeSelector" value="6B"  style={{backgroundColor:"var(--grade45)"}}>6B</option>
            <option className="optionGradeSelector" value="6B+" style={{backgroundColor:"var(--grade45)"}}>6B+</option>
            <option className="optionGradeSelector" value="6C"  style={{backgroundColor:"var(--grade45)"}}>6C</option>
            <option className="optionGradeSelector" value="6C+" style={{backgroundColor:"var(--grade45)"}}>6C+</option>
            <option className="optionGradeSelector" value="7A"  style={{backgroundColor:"var(--grade67)"}}>7A</option>
            <option className="optionGradeSelector" value="7A+" style={{backgroundColor:"var(--grade67)"}}>7A+</option>
            <option className="optionGradeSelector" value="7B"  style={{backgroundColor:"var(--grade89)"}}>7B</option>
            <option className="optionGradeSelector" value="7C"  style={{backgroundColor:"var(--grade89)"}}>7C</option>
            <option className="optionGradeSelector" value="7C+" style={{backgroundColor:"var(--grade1011)"}}>7C+</option>
            <option className="optionGradeSelector" value="8A"  style={{backgroundColor:"var(--grade1011)"}}>8A</option>
            <option className="optionGradeSelector" value="8A+" style={{backgroundColor:"var(--grade1213)"}}>8A+</option>
            <option className="optionGradeSelector" value="8B"  style={{backgroundColor:"var(--grade1213)"}}>8B</option>
            <option className="optionGradeSelector" value="8B+" style={{backgroundColor:"var(--grade1415)"}}>8B+</option>
            <option className="optionGradeSelector" value="8C"  style={{backgroundColor:"var(--grade1415)"}}>8C</option>
            <option className="optionGradeSelector" value="8C+" style={{backgroundColor:"var(--grade1617)"}}>8C+</option>
            <option className="optionGradeSelector" value="9A"  style={{backgroundColor:"var(--grade1617)"}}>9A</option>
        </>
        }
    </select>
    )
  }


  export default GradeSelector;